//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      csrftoken: '',
    };
  },
  mounted() {
    this.csrftoken = this.$cookies.get('csrftoken');
  },
};
